import React from 'react'
import { Col, Row, Radio } from 'antd';


function Primary({ setPrimaryHazard, newReport, maxHazardsRadios, hazardCharacteristicsRadios, hazardElevationRadios, hazardAspectsRadios, avalancheSizesRadios, hazardLikelihoodRadios, hazardSurfaceConditionsRadios }) {

    const onHazardChange = (value) => {
        const arr = value.split("_")
        const hazardId = parseInt(arr[0])
        const elevationId = parseInt(arr[1])
        // console.log(hazardId);
        setPrimaryHazard({ ...newReport.primaryHazard, hazardId: hazardId, elevationId: elevationId, characteristicId: 0 })
    }

    //if levation id is 3 select first hazraaßd
    var selectedHazard = newReport.primaryHazard.hazardId + "_" + newReport.primaryHazard.elevationId

    if (newReport.primaryHazard.elevationId === 3) {
        // selectedHazard = newReport.primaryHazard.hazardId + "_" + 1
        for (var i = 0; i < maxHazardsRadios.length; i++) {
            var value = maxHazardsRadios[i].props.children[0].props.value
            var arr = value.split("_");
            if (parseInt(arr[0]) === newReport.primaryHazard.hazardId) {
                selectedHazard = value;
                break;
            }
        }
    }

    return (
        <div>
            <Row>
                <Col md={12} sm={24}>
                    <h3 className="report-form-h3">Primary Hazard</h3>
                    <Radio.Group onChange={e => onHazardChange(e.target.value)} value={selectedHazard}>
                        {maxHazardsRadios}
                    </Radio.Group>
                </Col>
            </Row>
            <br />
            <br />
            {
                (newReport.primaryHazard.hazardId !== 0)
                    ?
                    (newReport.primaryHazard.hazardId !== 20 && newReport.primaryHazard.hazardId !== 19 && newReport.primaryHazard.hazardId !== 18)
                        ?

                        <div>
                            <Row>
                                <Col md={24} sm={24}>
                                    <h3 className="report-form-h3">Avalanche danger</h3>
                                    <Row style={{ marginTop: 10 }}>
                                        <Col md={8} sm={24}>
                                            <label className="report-form-lbl">Hazard characteristics</label>
                                            <br />
                                            <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, characteristicId: e.target.value })} value={newReport.primaryHazard.characteristicId} style={{ marginTop: 5 }}>
                                                {hazardCharacteristicsRadios}
                                            </Radio.Group>
                                        </Col>
                                    </Row>
                                    <br />

                                    {
                                        (newReport.primaryHazard.characteristicId !== 9)
                                            ?
                                            <Row>

                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Hazard elevation</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, elevationId: e.target.value })} value={newReport.primaryHazard.elevationId} style={{ marginTop: 5 }}>
                                                        {hazardElevationRadios}
                                                    </Radio.Group>
                                                </Col>

                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Hazard aspect</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, aspectId: e.target.value })} value={newReport.primaryHazard.aspectId} style={{ marginTop: 5 }}>
                                                        {hazardAspectsRadios}
                                                    </Radio.Group>
                                                </Col>

                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Hazard likelihood</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, likelihoodId: e.target.value })} value={newReport.primaryHazard.likelihoodId} style={{ marginTop: 5 }}>
                                                        {hazardLikelihoodRadios}
                                                    </Radio.Group>
                                                </Col>

                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Avalanche size</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, avalancheSizesId: e.target.value })} value={newReport.primaryHazard.avalancheSizesId} style={{ marginTop: 5 }}>
                                                        {avalancheSizesRadios}
                                                    </Radio.Group>
                                                </Col>
                                            </Row>

                                            :

                                            <Row>
                                                <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                                    <label className="report-form-lbl">Hazard elevation</label>
                                                    <br />
                                                    <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, elevationId: e.target.value })} value={newReport.primaryHazard.elevationId} style={{ marginTop: 5 }}>
                                                        {hazardElevationRadios}
                                                    </Radio.Group>
                                                </Col>
                                            </Row>
                                    }


                                    <br />
                                    <Row>
                                        <Col md={24} sm={24}>
                                            <label className="report-form-lbl">Summary</label>
                                            <br />
                                            <textarea className="ant-input text-area-" rows={4} onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, summary: e.target.value })} value={newReport.primaryHazard.summary} style={{ marginTop: 5 }} />
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>

                        </div>
                        :

                        <div>
                            <Row>
                                <Col md={24} sm={24}>
                                    {/* <h3>Avalanche danger</h3> */}
                                    <Row>
                                        <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                            <label className="report-form-lbl">Hazard elevation</label>
                                            <br />
                                            <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, elevationId: e.target.value })} value={newReport.primaryHazard.elevationId} style={{ marginTop: 5 }}>
                                                {hazardElevationRadios}
                                            </Radio.Group>
                                        </Col>
                                        <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                            <label className="report-form-lbl">Hazard aspect</label>
                                            <br />
                                            <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, aspectId: e.target.value })} value={newReport.primaryHazard.aspectId} style={{ marginTop: 5 }}>
                                                {hazardAspectsRadios}
                                            </Radio.Group>
                                        </Col>
                                        {/* <Col md={24} sm={24} style={{ marginTop: 30 }}>
                                            <label className="report-form-lbl">Sliding hazard</label>
                                            <br />
                                            <Radio.Group onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, surfaceConditionId: e.target.value })} value={newReport.primaryHazard.surfaceConditionId} style={{ marginTop: 5 }}>
                                                {hazardSurfaceConditionsRadios}
                                            </Radio.Group>
                                        </Col> */}
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col md={24} sm={24}>
                                            <label className="report-form-lbl">Summary</label>
                                            <br />
                                            <textarea className="ant-input text-area-" rows={4} onChange={e => setPrimaryHazard({ ...newReport.primaryHazard, summary: e.target.value })} value={newReport.primaryHazard.summary} style={{ marginTop: 5 }} />
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>

                        </div>
                    :
                    null
            }
        </div>
    )
}


export default Primary
